import { Button, Tooltip } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { FormattedMessage } from 'react-intl';
import Messages from 'i18n/messages/common';

const FormSaveButton = (props) => {
  const { text, style, title, tooltipProps, ...restProps } = props;
  return (
    <Tooltip title={title} {...tooltipProps}>
      <Button
        type='primary'
        style={{ borderRadius: '4px', ...style }}
        icon={<SaveOutlined />}
        {...restProps}
      >
        <span>{text || <FormattedMessage {...Messages.saveBtn} />}</span>
      </Button>
    </Tooltip>
  );
};

export default FormSaveButton;
